// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import swotItemEntity from './entities/swot-item.json';
import swotItemMenu from '../pages/swot-item/menu.json';
import swotItemFullForm from '../pages/swot-item/forms/full.json';
import swotItemContextForm from '../pages/swot-item/forms/context.json';
import swotItemMiniForm from '../pages/swot-item/forms/mini.json';
import swotItemLookupForm from '../pages/swot-item/forms/lookup.json';
import swotItemTableView from '../pages/swot-item/views/table.json';
import swotItemCardsView from '../pages/swot-item/views/cards.json';
import swotItemDashboardView from '../pages/swot-item/views/dashboard.json';

/** Тип запису «Елемент SWOT» зі сторінками пакета: меню, форми та подання з pages/swot-item/. */
export const swotItemDefinition: IRecordTypeDefinition = {
  ...swotItemEntity,
  views: assembleViewSet({
      table: swotItemTableView,
      cards: swotItemCardsView,
      dashboard: swotItemDashboardView,
  }),
  form: swotItemFullForm,
  forms: { full: swotItemFullForm, context: swotItemContextForm, mini: swotItemMiniForm, lookup: swotItemLookupForm },
  menu: swotItemMenu,
} as IRecordTypeDefinition;
